(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const MOUVEMENT_REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');
    const instances = [];

    const demarrer = (barre) => {
      if (barre.dataset.announcementPret) return;
      if (typeof window.Swiper !== 'function') return;

      const piste = barre.querySelector('.swiper-wrapper');
      const diapos = piste ? [...piste.children] : [];
      if (!diapos.length) return;

      for (const diapo of diapos) diapo.classList.add('swiper-slide');
      barre.dataset.announcementPret = '1';

      let delai = Number.parseInt(barre.getAttribute('data-announcement-interval'), 10);
      if (!delai || delai < 2) delai = 5;

      const plusieurs = diapos.length > 1;
      const anime =
        plusieurs && !barre.hasAttribute('data-announcement-arret') && !MOUVEMENT_REDUIT.matches;

      instances.push(
        new window.Swiper(barre, {
          slidesPerView: 1,
          loop: plusieurs,
          autoHeight: true,
          speed: 300,
          allowTouchMove: plusieurs,
          a11y: { enabled: false },
          autoplay: anime
            ? { delay: delai * 1000, disableOnInteraction: false, pauseOnMouseEnter: true }
            : false,
        })
      );
    };

    const init = () => {
      for (const barre of document.querySelectorAll('[data-announcement]')) demarrer(barre);
    };

    const detruire = () => {
      while (instances.length) {
        const it = instances.pop();
        if (it && !it.destroyed) it.destroy(true, true);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('load', init);
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', detruire);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (root.dataset.buyBoxGalleryReady || typeof Swiper === 'undefined') return;
      var layout = root.querySelector('[data-buy-box]') || root;
      var el = root.querySelector('[data-buy-box-swiper]');
      if (!el) return;
      var slides = el.querySelectorAll('.swiper-slide');
      if (slides.length < 2) return;
      root.dataset.buyBoxGalleryReady = 'true';

      var thumbsEl = root.querySelector('[data-buy-box-thumbs]');
      var thumbsSwiper = null;
      if (thumbsEl) {
        thumbsSwiper = new Swiper(thumbsEl, {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 6,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true
        });
      }

      var thumb = root.querySelector('[data-buy-box-progress-thumb]');
      if (thumb) thumb.style.width = 100 / slides.length + '%';

      function sync(sw) {
        if (!thumb) return;
        thumb.style.transform = 'translateX(' + sw.activeIndex * 100 + '%)';
      }

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        watchOverflow: true,
        enabled: true,
        breakpoints: { 990: { enabled: layout.dataset.buyBoxGalleryDesktop === 'true' } },
        thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
        observer: true,
        observeParents: true,
        on: { init: sync, slideChange: sync }
      });
    }

    function bootGallery() {
      document.querySelectorAll('[data-buy-box]').forEach(function (root) {
        initGallery(root.closest('[data-section-type]') || root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootGallery);
    } else {
      bootGallery();
    }
    window.addEventListener('load', bootGallery);
    document.addEventListener('shopify:section:load', bootGallery);

    var BUREAU = window.matchMedia('(min-width: 990px)');
    var MOUVEMENT_REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');

    function pilote(section) {
      var inner = section.querySelector('.buy-box__inner');
      var form = section.querySelector('.buy-box__scroll');
      var espaceur = section.querySelector('[data-buy-box-travel]');
      if (!inner || !form) return null;

      function course() {
        return Math.max(0, form.scrollHeight - form.clientHeight);
      }

      function mesurer() {
        if (!espaceur) return;
        var ancienne = parseFloat(espaceur.style.height) || 0;
        var c = course();
        espaceur.style.height = BUREAU.matches ? c + 'px' : '0px';
        if (!BUREAU.matches || MOUVEMENT_REDUIT.matches) return;

        var haut = inner.getBoundingClientRect().top;
        var epingle = haut <= 36;
        var position = 36 - haut;
        if (ancienne > 0 && epingle && position > c) {
          window.scrollBy(0, c - position);
        }
      }

      function suivre() {
        if (!BUREAU.matches || MOUVEMENT_REDUIT.matches) return;
        var c = course();
        if (c <= 0) return;
        var haut = inner.getBoundingClientRect().top;
        var avancee = Math.min(Math.max((36 - haut) / c, 0), 1);
        form.scrollTop = avancee * c;
      }

      return { mesurer: mesurer, suivre: suivre };
    }

    function brancherEpinglage() {
      document.querySelectorAll('[data-section-type="buy-box"]').forEach(function (section) {
        if (section.dataset.buyBoxPinReady) return;
        var p = pilote(section);
        if (!p) return;
        section.dataset.buyBoxPinReady = 'true';
        p.mesurer();
        p.suivre();
        window.addEventListener('scroll', p.suivre, { passive: true });
        window.addEventListener('resize', function () { p.mesurer(); p.suivre(); });
        var zone = section.querySelector('.buy-box__scroll');

        if (window.ResizeObserver) {
          var oeil = new ResizeObserver(function () { p.mesurer(); });
          Array.prototype.forEach.call(zone.children, function (enfant) {
            oeil.observe(enfant);
            if (getComputedStyle(enfant).display === 'contents') {
              Array.prototype.forEach.call(enfant.children, function (pe) { oeil.observe(pe); });
            }
          });
        }

        zone.addEventListener('transitionend', p.mesurer);
        zone.addEventListener('change', p.mesurer);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancherEpinglage);
    } else {
      brancherEpinglage();
    }
    window.addEventListener('load', brancherEpinglage);
    document.addEventListener('shopify:section:load', brancherEpinglage);

    /* Le checkout ne doit contenir QUE la sélection en cours. Sans ça, un
       acheteur qui revient sur la page et choisit un autre palier arrive au
       checkout avec les deux lignes empilées.

       On vide donc le panier avant d'ajouter. Le formulaire natif reste la
       solution de repli : si le JS échoue ou n'est pas là, la soumission
       normale s'applique — l'achat passe, sans le nettoyage. */
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.buy-box__form');
      if (!form) return;

      var champId = form.querySelector('[name="id"]');
      var champQte = form.querySelector('[name="quantity"]');
      if (!champId || !champId.value) return;

      event.preventDefault();
      var bouton = form.querySelector('[type="submit"]');
      if (bouton) bouton.disabled = true;

      var corps = {
        items: [{ id: Number(champId.value), quantity: Number(champQte && champQte.value) || 1 }],
      };

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(corps),
          });
        })
        .then(function (reponse) {
          if (!reponse.ok) throw new Error('ajout refuse');
          window.location.href = '/checkout';
        })
        .catch(function () {
          /* Rupture de stock, réseau coupé : on rend la main au formulaire,
             qui affichera le message d'erreur de Shopify. */
          if (bouton) bouton.disabled = false;
          form.submit();
        });
    });

    function apply(input) {
      var root = input.closest('[data-buy-box]');
      if (!root) return;

      /* Un bundle est une variante à part entière : on repose l'identifiant,
         et la quantité reste à 1 — c'est le bundle qui porte le lot. */
      var champVariante = root.querySelector('[data-buy-box-variant]');
      if (champVariante) champVariante.value = input.value;

      var champQuantite = root.querySelector('[data-buy-box-quantity]');
      if (champQuantite) champQuantite.value = input.dataset.quantity || '1';

      var price = root.querySelector('[data-buy-box-price]');
      if (price && input.dataset.price) price.textContent = input.dataset.price;

      var compare = root.querySelector('[data-buy-box-compare]');
      if (compare) {
        if (input.dataset.compare) {
          compare.textContent = input.dataset.compare;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-buy-box-offer]');
      if (input) apply(input);
    });

    function hydrate() {
      var checked = document.querySelectorAll('[data-buy-box-offer]:checked');
      for (var i = 0; i < checked.length; i++) apply(checked[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrate);
    } else {
      hydrate();
    }
    document.addEventListener('shopify:section:load', hydrate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["claims-bar"] && !Shopify.designMode) return;
  try {
    

  (() => {
    'use strict';

    const init = (el) => {
      if (el.dataset.marqueeReady) return;
      const track = el.querySelector('[data-marquee-track]');
      if (!track || track.children.length < 2) return;

      el.dataset.marqueeReady = 'true';

      for (const node of [...track.children]) {
        const clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      el.classList.add('is-animating');
    };

    const boot = () => {
      for (const el of document.querySelectorAll('[data-marquee]')) init(el);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doc"]) return;
  try {
    
  (function () {
    function brancher() {
      document.querySelectorAll('[data-doc]').forEach(function (doc) {
        if (doc.dataset.docReady) return;
        var nav = doc.querySelector('[data-doc-nav]');
        var chapitres = doc.querySelectorAll('[data-doc-chapter]');
        if (!nav || !chapitres.length) return;
        doc.dataset.docReady = 'true';

        var groupeCourant = null;
        chapitres.forEach(function (ch) {
          var groupe = ch.getAttribute('data-doc-group');
          if (groupe && groupe !== groupeCourant) {
            groupeCourant = groupe;
            var t = document.createElement('p');
            t.className = 'doc__nav-group';
            t.textContent = groupe;
            nav.appendChild(t);
          }
          var a = document.createElement('a');
          a.className = 'doc__nav-link';
          a.href = '#' + ch.id;
          a.textContent = ch.getAttribute('data-doc-title') || ch.id;
          nav.appendChild(a);
        });

        var liens = nav.querySelectorAll('.doc__nav-link');
        function suivre() {
          var repere = window.innerHeight / 3;
          var actif = null;
          chapitres.forEach(function (ch, i) {
            if (ch.getBoundingClientRect().top <= repere) actif = i;
          });
          liens.forEach(function (l, i) {
            if (i === actif) l.setAttribute('aria-current', 'true');
            else l.removeAttribute('aria-current');
          });
        }
        var enAttente = false;
        window.addEventListener('scroll', function () {
          if (enAttente) return;
          enAttente = true;
          window.requestAnimationFrame(function () { enAttente = false; suivre(); });
        }, { passive: true });
        suivre();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
    document.addEventListener('shopify:section:load', brancher);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const amener = () => {
      const msg = document.querySelector('.footer__form-success');
      if (!msg) return;

      if (msg.hidden) {
        msg.hidden = false;
        const champ = document.querySelector('#newsletter-footer .footer__form');
        if (champ) champ.hidden = true;
      }

      msg.setAttribute('tabindex', '-1');
      msg.scrollIntoView({ block: 'center' });
    };

    const demande =
      /[?&]customer_posted=true/.test(window.location.search) ||
      window.location.hash === '#newsletter-footer';

    if (demande) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', amener);
      } else {
        amener();
      }
      window.addEventListener('load', () => window.requestAnimationFrame(amener));
    }
  })();

  (() => {
    'use strict';

    const racine = document.documentElement;
    const TOUCHES = new Set(['Tab', 'ArrowDown', 'ArrowUp']);

    document.addEventListener(
      'keydown',
      (e) => {
        if (TOUCHES.has(e.key)) racine.setAttribute('data-clavier', '');
      },
      true
    );

    document.addEventListener('pointerdown', () => racine.removeAttribute('data-clavier'), true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /* Hauteur de la carte : le bas de la barre de claims doit tomber sur le bas
     de l'écran.

     Tous les termes du calcul sont INDÉPENDANTS de la hauteur cherchée — le
     haut de la carte, ce que la section ajoute sous elle, l'écart entre les
     deux sections et la hauteur des claims ne bougent pas quand la carte
     grandit. Une seule passe suffit donc, sans boucle de rétroaction.

     ⚠️ Sur mobile, scroller replie/déplie la barre d'URL du navigateur :
     `window.innerHeight` varie d'environ 60px et `resize` se déclenche EN
     COURS DE SCROLL. Recalculer à ce moment fait grandir la carte sous le
     doigt, ce qui décale tout le document et fait sauter le scroll.
     On ne réagit donc à un `resize` que quand la LARGEUR change (rotation,
     fenêtre redimensionnée). Une variation de hauteur seule est ignorée sous
     990px ; en desktop il n'y a pas de barre escamotable, on la prend. */
  (function () {
    var dernierW = window.innerWidth;
    var dernierH = window.innerHeight;
    var planifie = false;

    function mesurer() {
      var carte = document.querySelector('.hero__card');
      var hero = document.querySelector('[data-section-type="hero"]');
      var claims = document.querySelector('[data-section-type="claims-bar"]');
      if (!carte || !hero || !claims) return;

      var racine = document.documentElement;
      var precedente = racine.style.getPropertyValue('--hero-card-height');

      carte.style.removeProperty('--hero-card-height');
      racine.style.removeProperty('--hero-card-height');

      var rc = carte.getBoundingClientRect();
      var rh = hero.getBoundingClientRect();
      var rb = claims.getBoundingClientRect();

      var hautCarte = rc.top + window.scrollY;
      var apres = rh.bottom - rc.bottom;       // ce que la section ajoute sous la carte
      var ecart = rb.top - rh.bottom;          // marge entre les deux sections
      var voulue = window.innerHeight - hautCarte - apres - ecart - rb.height;

      // Jamais plus court que la maquette : le plancher est dans la feuille.
      if (voulue > 0) {
        racine.style.setProperty('--hero-card-height', Math.round(voulue) + 'px');
      } else if (precedente) {
        // Mesure inexploitable : on remet la valeur connue plutôt que de
        // laisser la carte retomber d'un coup sur le plancher de la feuille.
        racine.style.setProperty('--hero-card-height', precedente);
      }
    }

    function ajuster() {
      if (planifie) return;
      planifie = true;
      window.requestAnimationFrame(function () {
        planifie = false;
        dernierW = window.innerWidth;
        dernierH = window.innerHeight;
        mesurer();
      });
    }

    function surResize() {
      var w = window.innerWidth;
      var h = window.innerHeight;

      if (w === dernierW) {
        // Largeur inchangée : sous 990px c'est la barre d'URL, on ne touche
        // à rien. On enregistre quand même la hauteur pour ne pas la rejouer.
        if (w < 990) {
          dernierH = h;
          return;
        }
        if (h === dernierH) return;
      }

      ajuster();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ajuster);
    } else {
      ajuster();
    }
    window.addEventListener('load', ajuster);
    window.addEventListener('resize', surResize);
    window.addEventListener('orientationchange', ajuster);
    document.addEventListener('shopify:section:load', ajuster);

    // La hauteur de la barre de claims dépend des fontes (Brandon Grotesque /
    // Rubik sont chargées en asynchrone) : une mesure prise avant le swap est
    // fausse. Ce recalcul-là tombe avant tout scroll utilisateur.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(ajuster);
    }
  })();

  (() => {
    'use strict';

    const reveler = () => {
      for (const hero of document.querySelectorAll('[data-hero-zoom]')) {
        if (hero.dataset.heroRevele) continue;
        hero.dataset.heroRevele = '1';
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => hero.classList.add('is-revealed'));
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveler);
    } else {
      reveler();
    }
    window.addEventListener('load', reveler);
    document.addEventListener('shopify:section:load', reveler);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-bar"]) return;
  try {
    
  (() => {
    'use strict';

    const init = () => {
      const bar = document.querySelector('[data-logo-bar]');
      if (!bar || bar.dataset.lbReady) return;
      bar.dataset.lbReady = 'true';

      const hero = document.querySelector('[data-section-type="hero"]');
      if (hero) {
        new IntersectionObserver(([entree]) => {
          bar.classList.toggle('is-pinned', !entree.isIntersecting);
        }).observe(hero);
      }

      /* Le seuil se mesure sur l'ENVELOPPE, pas sur la barre.

         `.logo-bar` grandit quand `.is-solid` lui est pose (68 -> 120.3px en
         desktop, 51 -> 71.1px en mobile). Mesurer sa hauteur pour decider de
         poser cette meme classe est une boucle de retroaction : a y = 70, le
         seuil valait 68, la classe etait posee, la barre passait a 120.3, le
         seuil devenait 120.3, la classe etait retiree, et ainsi de suite.
         Mesure avant correctif, de y = 70 a y = 130 par pas de 10 :
         true / false / true / false / true -- la barre clignotait sur toute
         cette bande.

         `.section--logo-bar` a une hauteur fixee par la feuille (68 desktop /
         51 mobile) qui ne bouge pas avec `.is-solid` : c'est une reference
         stable, et elle reste synchronisee avec le CSS. */
      const enveloppe = bar.closest('.section--logo-bar') || bar;

      let derniere = window.scrollY;
      let enAttente = false;

      const evaluer = () => {
        enAttente = false;
        const y = window.scrollY;
        const seuil = enveloppe.getBoundingClientRect().height || 84;

        bar.classList.toggle('is-solid', y > seuil);

        if (y <= seuil) {
          derniere = y;
          bar.classList.remove('is-hidden');
          return;
        }

        const pas = y - derniere;

        /* La reference n'est PAS remise a jour tant que le mouvement reste sous
           le seuil : sinon un defilement lent est perdu frame apres frame et ne
           declenche jamais rien. */
        if (pas > -5 && pas < 5) return;

        derniere = y;
        bar.classList.toggle('is-hidden', pas > 0);
      };

      window.addEventListener(
        'scroll',
        () => {
          if (enAttente) return;
          enAttente = true;
          window.requestAnimationFrame(evaluer);
        },
        { passive: true }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["peptides"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyHeading(root, panel) {
      ['top', 'bottom'].forEach(function (part) {
        var target = root.closest('[data-section-id]').querySelector('[data-peptides-heading-' + part + ']');
        if (!target) return;
        if (!target.dataset.pepDefault) target.dataset.pepDefault = target.innerHTML;
        var source = panel && panel.querySelector('.peptides-panel__heading-' + part);
        target.innerHTML = source ? source.innerHTML : target.dataset.pepDefault;
      });
    }

    function build(root) {
      if (root.dataset.pepReady) return;
      var list = root.querySelector('[data-peptides-tabs]');
      var panels = root.querySelectorAll('[data-peptides-panel]');
      if (!list || !panels.length) return;
      root.dataset.pepReady = 'true';

      panels.forEach(function (panel, index) {
        var id = panel.getAttribute('data-peptides-panel');
        var wrapper = panel.parentElement;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'peptides__step';
        button.setAttribute('role', 'tab');
        button.id = 'pep-tab-' + id;
        button.setAttribute('aria-controls', 'pep-panel-' + id);
        button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        button.setAttribute('data-peptides-tab', id);
        if (index === 0) button.setAttribute('data-active', '');

        var number = document.createElement('span');
        number.className = 'peptides__step-number p-large';
        number.textContent = ('0' + (index + 1)).slice(-2);
        button.appendChild(number);

        var label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = panel.getAttribute('data-label') || number.textContent;
        button.appendChild(label);

        list.appendChild(button);
        if (index === 0) {
          wrapper.setAttribute('data-active', '');
          applyHeading(root, panel);
        }
      });

      root.classList.add('is-enhanced');
      reserver(root);
      window.addEventListener('resize', function () { reserver(root); });

      /* Auto-reparation : la reserve est calculee a partir de hauteurs de
         texte et d'images. Si elle est posee avant que les polices ou les
         visuels soient prets, elle est fausse et rien ne la corrigeait —
         d'ou un bloc decale qui se remet d'aplomb au rechargement.
         L'observateur recalcule des que le contenu change de taille. */
      if (window.ResizeObserver) {
        var enCours = false;
        var ro = new ResizeObserver(function () {
          if (enCours || root.enTransition || root.enMesure) return;
          enCours = true;
          window.requestAnimationFrame(function () {
            enCours = false;
            reserver(root);
          });
        });
        root.observateurTaille = ro;
        root.querySelectorAll('[data-peptides-panel]').forEach(function (p) { ro.observe(p); });
        var titre = root.querySelector('.peptides__heading');
        if (titre) ro.observe(titre);
      }

      root.querySelectorAll('.peptides__right img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () { reserver(root); }, { once: true });
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { reserver(root); });
      }
      window.addEventListener('load', function () { reserver(root); });
    }

    function reserverTitre(root) {
      var titre = root.querySelector('.peptides__heading');
      if (!titre) return;

      var panneaux = root.querySelectorAll('[data-peptides-panel]');
      if (panneaux.length < 2) return;

      var courant = root.querySelector('.peptides__right > div[data-active] [data-peptides-panel]');
      titre.style.minHeight = '';
      var haut = 0;

      for (var i = 0; i < panneaux.length; i++) {
        applyHeading(root, panneaux[i]);
        var h = titre.getBoundingClientRect().height;
        if (h > haut) haut = h;
      }

      applyHeading(root, courant);
      if (haut > 0) titre.style.minHeight = Math.ceil(haut) + 'px';
    }

    function reserver(root) {
      var scene = root.querySelector('.peptides__right');
      if (!scene) return;

      /* Garde pose dans la fonction et pas seulement dans l'observateur :
         load, fonts.ready et resize l'appellent aussi, et une mesure pendant
         le glissement secoue la scene. Elle est rejouee apres coup. */
      if (root.enTransition) {
        root.remesureEnAttente = true;
        return;
      }

      /* La mesure bascule data-active sur chaque panneau, ce qui change leur
         taille et rappelle l'observateur. On ne le deconnecte PAS — le
         reconnecter relance une salve initiale et la boucle s'emballe. Un
         drapeau suffit : l'observateur ignore ce que la mesure provoque. */
      root.enMesure = true;
      var enveloppes = scene.querySelectorAll(':scope > div');
      if (enveloppes.length < 2) return;

      scene.style.minHeight = '';
      var actif = scene.querySelector(':scope > div[data-active]');
      var haut = 0;
      var j;

      for (j = 0; j < enveloppes.length; j++) enveloppes[j].removeAttribute('data-active');

      for (var i = 0; i < enveloppes.length; i++) {
        enveloppes[i].setAttribute('data-active', '');
        var h = enveloppes[i].getBoundingClientRect().height;
        if (h > haut) haut = h;
        enveloppes[i].removeAttribute('data-active');
      }

      if (actif) actif.setAttribute('data-active', '');
      else if (enveloppes[0]) enveloppes[0].setAttribute('data-active', '');
      if (haut > 0) scene.style.minHeight = Math.ceil(haut) + 'px';

      reserverTitre(root);

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { root.enMesure = false; });
      });
    }

    function boot() {
      document.querySelectorAll('[data-peptides]').forEach(build);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);

    function activer(root, tab) {
      var id = tab.getAttribute('data-peptides-tab');
      if (tab.hasAttribute('data-active')) return;

      var onglets = [].slice.call(root.querySelectorAll('[data-peptides-tab]'));
      var vers = onglets.indexOf(tab);
      var depuis = onglets.indexOf(root.querySelector('[data-peptides-tab][data-active]'));

      /* Le sens est pose AVANT d'activer le panneau, et sans transition : sinon
         l'entrant part de sa position de repos precedente et glisse du mauvais
         cote. Il est invisible a cet instant, le repositionnement ne se voit
         pas. La transition est rendue a la frame suivante. */
      root.setAttribute('data-sans-transition', '');
      root.setAttribute('data-sens', vers < depuis ? 'arriere' : 'avant');
      void root.offsetWidth;
      root.removeAttribute('data-sans-transition');

      /* Aucune remesure pendant le glissement : elle ferait clignoter la scene. */
      root.enTransition = true;
      if (root.minuteurTransition) window.clearTimeout(root.minuteurTransition);
      root.minuteurTransition = window.setTimeout(function () {
        root.minuteurTransition = null;
        root.enTransition = false;
        if (root.remesureEnAttente) {
          root.remesureEnAttente = false;
          reserver(root);
        }
      }, 500);

      root.querySelectorAll('[data-peptides-tab]').forEach(function (t) {
        var on = t === tab;
        if (on) t.setAttribute('data-active', '');
        else t.removeAttribute('data-active');
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      root.querySelectorAll('.peptides__right > div').forEach(function (wrapper) {
        var panel = wrapper.querySelector('[data-peptides-panel]');
        var on = panel && panel.getAttribute('data-peptides-panel') === id;

        if (on) {
          wrapper.removeAttribute('data-sortant');
          wrapper.setAttribute('data-active', '');
          applyHeading(root, panel);
        } else if (wrapper.hasAttribute('data-active')) {
          wrapper.removeAttribute('data-active');
          wrapper.setAttribute('data-sortant', '');
          if (wrapper.minuteurSortie) window.clearTimeout(wrapper.minuteurSortie);
          wrapper.minuteurSortie = window.setTimeout(function () {
            wrapper.minuteurSortie = null;
            wrapper.removeAttribute('data-sortant');
          }, 400);
        } else if (wrapper.hasAttribute('data-sortant')) {
          if (wrapper.minuteurSortie) window.clearTimeout(wrapper.minuteurSortie);
          wrapper.minuteurSortie = null;
          wrapper.removeAttribute('data-sortant');
        }
      });
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-peptides-tab]');
      if (!tab) return;
      var root = tab.closest('[data-peptides]');
      if (root) activer(root, tab);
    });

    var SURVOL_FIN = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.addEventListener('pointerenter', function (event) {
      if (!SURVOL_FIN.matches) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var tab = event.target.closest && event.target.closest('[data-peptides-tab]');
      if (!tab) return;
      var root = tab.closest('[data-peptides]');
      if (root) activer(root, tab);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const init = (root) => {
      if (root.dataset.rcReady || typeof Swiper === 'undefined') return;
      const el = root.querySelector('[data-rc-swiper]');
      if (!el) return;
      root.dataset.rcReady = 'true';

      const prev = root.querySelector('[data-rc-prev]');
      const next = root.querySelector('[data-rc-next]');

      const piste = el.querySelector('.swiper-wrapper');
      if (piste) {
        for (const enfant of piste.children) enfant.classList.add('swiper-slide');
      }

      const mobile = window.matchMedia('(max-width: 989px)').matches;

      const sync = (sw) => {
        const instance = sw ?? el.swiper;
        if (!instance) return;
        if (prev) prev.disabled = instance.isBeginning;
        if (next) next.disabled = instance.isEnd;
      };

      /* Swiper 11 refuse SILENCIEUSEMENT la boucle quand il n'y a pas assez de
         diapos pour remplir deux fois la piste : il ne clone rien, et le
         carrousel bute au lieu de tourner. Mesure avant correction, avec
         `loop: true` deja pose : aucun clone, parcours bloque sur « 0 1 1 1 ».

         Avec 5 temoignages pour environ 4,4 visibles en desktop, on est juste
         en dessous. On duplique donc la serie d'origine autant de fois qu'il
         faut : l'acheteur voit de toute facon ces memes temoignages a chaque
         tour, et Swiper a enfin de quoi cloner.

         Les copies portent `data-rc-copie` : le bouton play est delegue au
         document, il continue donc d'y fonctionner. */
      const piste2 = el.querySelector('.swiper-wrapper');
      if (piste2) {
        const origine = Array.prototype.slice.call(piste2.children);
        const parEcran = Math.max(1, Math.ceil(el.clientWidth / Math.max(1, origine[0] ? origine[0].getBoundingClientRect().width : 1)));
        const minimum = (parEcran + 1) * 2;
        let garde = 0;
        while (piste2.children.length < minimum && origine.length && garde < 6) {
          origine.forEach(function (diapo) {
            const copie = diapo.cloneNode(true);
            copie.setAttribute('data-rc-copie', '');
            piste2.appendChild(copie);
          });
          garde += 1;
        }
      }

      const swiper = new Swiper(el, {
        slidesPerView: 'auto',
        initialSlide: mobile ? 1 : 0,
        /* Boucle infinie : apres la derniere affiche on revient sur la
           premiere sans buter. Swiper clone des diapos aux deux extremites ;
           `loopAdditionalSlides` en garde assez d'avance pour que le raccord
           ne se voie pas avec des diapos de largeur libre.
           Consequence voulue : les fleches ne se desactivent plus jamais,
           `isBeginning` et `isEnd` restant faux en permanence. */
        loop: true,
        loopAdditionalSlides: 2,
        /* La mise a l'echelle des laterales les retracte de (256 - 236.64) / 2
           = 9.68px de chaque cote sans changer leur boite de mise en page.
           L'espacement de mise en page est donc reduit d'autant pour que
           l'ecart VISUEL retombe sur les 6px de la maquette. */
        spaceBetween: -3.68,
        centeredSlides: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        breakpoints: { 990: { spaceBetween: 30, centeredSlides: false } },
        on: { init: sync, slideChange: sync, resize: sync },
      });

      prev?.addEventListener('click', () => swiper.slidePrev());
      next?.addEventListener('click', () => swiper.slideNext());
      sync(swiper);
    };

    const boot = () => {
      for (const root of document.querySelectorAll('[data-section-type="results-carousel"]')) init(root);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    window.addEventListener('load', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-immediate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(root) {
      if (root.dataset.riReady) return;
      var list = root.querySelector('[data-results-tabs]');
      var groups = root.querySelectorAll('[data-results-group]');
      if (!list || !groups.length) return;
      root.dataset.riReady = 'true';

      groups.forEach(function (group, index) {
        var id = group.getAttribute('data-results-group');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'results__tab';
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        button.setAttribute('data-results-tab', id);
        button.id = 'ri-tab-' + id;
        button.setAttribute('aria-controls', 'ri-panel-' + id);
        /* Roving tabindex : un seul onglet dans l'ordre de tabulation, on
           circule ensuite aux fleches, comme l'attend le motif tablist. */
        button.tabIndex = index === 0 ? 0 : -1;
        if (index === 0) button.setAttribute('data-active', '');

        var panneau = group.parentElement;
        panneau.id = 'ri-panel-' + id;
        panneau.setAttribute('role', 'tabpanel');
        panneau.setAttribute('aria-labelledby', 'ri-tab-' + id);
        button.textContent = group.getAttribute('data-label') || '';
        if (index > 0) {
          var filet = document.createElement('span');
          filet.className = 'results__tab-rule';
          filet.setAttribute('aria-hidden', 'true');
          list.appendChild(filet);
        }
        list.appendChild(button);
        if (index === 0) group.parentElement.setAttribute('data-active', '');
      });

      root.classList.add('is-enhanced');
      reserverGroupes(root);
      window.addEventListener('resize', function () { reserverGroupes(root); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { reserverGroupes(root); });
      }
      if (window.ResizeObserver) {
        var enCours = false;
        var ro = new ResizeObserver(function () {
          if (enCours) return;
          enCours = true;
          window.requestAnimationFrame(function () { enCours = false; reserverGroupes(root); });
        });
        root.querySelectorAll('[data-results-group]').forEach(function (g) { ro.observe(g); });
      }
    }

    /* Les groupes deviennent absolus pour glisser : sans hauteur reservee,
       le bloc s'effondrerait. On reserve celle du groupe le plus haut. */
    function reserverGroupes(root) {
      var piste = root.querySelector('.results__groups');
      if (!piste) return;
      var enveloppes = piste.querySelectorAll(':scope > div');
      if (enveloppes.length < 2) return;

      piste.style.minHeight = '';
      var actif = piste.querySelector(':scope > div[data-active]');
      var haut = 0;
      var j;

      for (j = 0; j < enveloppes.length; j++) enveloppes[j].removeAttribute('data-active');
      for (j = 0; j < enveloppes.length; j++) {
        enveloppes[j].setAttribute('data-active', '');
        var h = enveloppes[j].getBoundingClientRect().height;
        if (h > haut) haut = h;
        enveloppes[j].removeAttribute('data-active');
      }

      if (actif) actif.setAttribute('data-active', '');
      else if (enveloppes[0]) enveloppes[0].setAttribute('data-active', '');
      if (haut > 0) piste.style.minHeight = Math.ceil(haut) + 'px';
    }

    function boot() {
      document.querySelectorAll('[data-results]').forEach(build);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);

    function activerOnglet(root, tab) {
      if (tab.hasAttribute('data-active')) return;
      var id = tab.getAttribute('data-results-tab');
      var onglets = [].slice.call(root.querySelectorAll('[data-results-tab]'));

      onglets.forEach(function (t) {
        var on = t === tab;
        if (on) t.setAttribute('data-active', '');
        else t.removeAttribute('data-active');
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      var piste = root.querySelector('.results__groups');
      var enveloppes = [].slice.call(root.querySelectorAll('.results__groups > div'));
      var rang = 0;

      enveloppes.forEach(function (wrapper, i) {
        var group = wrapper.querySelector('[data-results-group]');
        var on = group && group.getAttribute('data-results-group') === id;
        if (on) {
          rang = i;
          wrapper.setAttribute('data-active', '');
        } else {
          wrapper.removeAttribute('data-active');
        }
      });

      /* Le groupe sortant reste visible le temps du glissement, sinon il
         disparait d'un coup au lieu de sortir du cadre. */
      if (piste) {
        enveloppes.forEach(function (w) { w.style.visibility = 'visible'; });
        piste.style.setProperty('--ri-index', rang);
        if (piste.minuteurPiste) window.clearTimeout(piste.minuteurPiste);
        piste.minuteurPiste = window.setTimeout(function () {
          piste.minuteurPiste = null;
          enveloppes.forEach(function (w) { w.style.visibility = ''; });
        }, 400);
      }

      onglets.forEach(function (t) { t.tabIndex = t === tab ? 0 : -1; });

    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-results-tab]');
      if (!tab) return;
      var root = tab.closest('[data-results]');
      if (root) activerOnglet(root, tab);
    });

    var POINTEUR_FIN = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest && event.target.closest('[data-results-tab]');
      if (!tab) return;
      var suivant = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') suivant = 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') suivant = -1;
      else if (event.key === 'Home') suivant = 'debut';
      else if (event.key === 'End') suivant = 'fin';
      if (suivant === null) return;

      var root = tab.closest('[data-results]');
      if (!root) return;
      var onglets = [].slice.call(root.querySelectorAll('[data-results-tab]'));
      var i = onglets.indexOf(tab);
      var cible;
      if (suivant === 'debut') cible = onglets[0];
      else if (suivant === 'fin') cible = onglets[onglets.length - 1];
      else cible = onglets[(i + suivant + onglets.length) % onglets.length];

      event.preventDefault();
      activerOnglet(root, cible);
      cible.focus();
    });

    document.addEventListener('pointerenter', function (event) {
      if (!POINTEUR_FIN.matches) return;
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var tab = event.target.closest && event.target.closest('[data-results-tab]');
      if (!tab) return;
      var root = tab.closest('[data-results]');
      if (root) activerOnglet(root, tab);
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function nombre(texte) {
      return (texte || '').replace(/\s+/g, ' ').trim();
    }

    function alimenter(section) {
      var maison = section.querySelector('[data-rv-head]');
      var widget = section.querySelector('.jm-review-widget-header, .jm-review-widget-minimal-header');
      if (!maison || !widget) return false;

      var textes = widget.querySelectorAll('.jm-average-rating-display .jm-text');
      if (textes.length < 2) return false;

      var moyenne = maison.querySelector('[data-rv-average]');
      var compte = maison.querySelector('[data-rv-count]');
      if (moyenne) moyenne.textContent = nombre(textes[0].textContent);
      if (compte) compte.textContent = nombre(textes[1].textContent);

      var lignes = widget.querySelectorAll('.jm-histogram-row');
      for (var i = 0; i < lignes.length; i++) {
        var note = nombre(lignes[i].querySelector('.jm-histogram-row__rating') ?
          lignes[i].querySelector('.jm-histogram-row__rating').textContent : '');
        var cible = maison.querySelector('[data-rv-row="' + note + '"]');
        if (!cible) continue;

        var freq = lignes[i].querySelector('.jm-histogram-row__frequency');
        var champ = cible.querySelector('[data-rv-frequency]');
        if (freq && champ) champ.textContent = '(' + nombre(freq.textContent) + ')';

        var etiquette = lignes[i].getAttribute('aria-label');
        if (etiquette) cible.setAttribute('aria-label', etiquette);
        var actif = lignes[i].getAttribute('aria-pressed') || lignes[i].getAttribute('aria-selected');
        if (actif) cible.setAttribute('aria-pressed', actif);

        var barre = cible.querySelector('[data-rv-fill]');
        if (barre) {
          var part = null;
          var pourcent = (etiquette || '').match(/(\d+(?:[.,]\d+)?)\s*%/);
          if (pourcent) part = parseFloat(pourcent[1].replace(',', '.'));
          if (part === null) {
            var piste = lignes[i].querySelector('.jm-progress-bar');
            var rempli = lignes[i].querySelector('.jm-progress-bar__fill');
            if (piste && rempli) {
              var large = piste.getBoundingClientRect().width;
              part = large > 0 ? (rempli.getBoundingClientRect().width / large) * 100 : 0;
            }
          }
          if (part !== null) barre.style.width = part.toFixed(2) + '%';
        }
      }

      widget.setAttribute('data-rv-remplace', '');
      maison.hidden = false;
      return true;
    }

    function brancher(section) {
      var maison = section.querySelector('[data-rv-head]');
      if (!maison || maison.dataset.rvBranche) return;
      maison.dataset.rvBranche = '1';

      var bouton = maison.querySelector('[data-rv-write]');
      if (bouton) {
        bouton.addEventListener('click', function () {
          var vrai = section.querySelector('.jm-button--primary, .jdgm-write-rev-link');
          if (vrai) vrai.click();
        });
      }

      var lignes = maison.querySelectorAll('[data-rv-row]');
      for (var i = 0; i < lignes.length; i++) {
        (function (ligne) {
          function relayer() {
            var note = ligne.getAttribute('data-rv-row');
            var cibles = section.querySelectorAll('.jm-histogram-row');
            for (var j = 0; j < cibles.length; j++) {
              var champ = cibles[j].querySelector('.jm-histogram-row__rating');
              if (champ && nombre(champ.textContent) === note) { cibles[j].click(); return; }
            }
          }
          ligne.addEventListener('click', relayer);
          ligne.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); relayer(); }
          });
        })(lignes[i]);
      }
    }

    function demarrer(section) {
      if (section.observateurAvis) section.observateurAvis.disconnect();

      var enAttente = false;

      function surveiller() {
        obs.observe(section, { childList: true, subtree: true });
      }

      var obs = new MutationObserver(function () {
        if (enAttente) return;
        enAttente = true;
        obs.disconnect();
        window.requestAnimationFrame(function () {
          alimenter(section);
          enAttente = false;
          surveiller();
        });
      });

      section.observateurAvis = obs;
      brancher(section);
      alimenter(section);
      surveiller();
    }

    function init() {
      var sections = document.querySelectorAll('[data-section-type="reviews"]');
      for (var i = 0; i < sections.length; i++) demarrer(sections[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"]) return;
  try {
    
  (() => {
    'use strict';

    const MOUVEMENT_REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');

    const equiper = (barre) => {
      if (barre.dataset.stickyCtaReady) return;
      barre.dataset.stickyCtaReady = 'true';

      const cibles = [...document.querySelectorAll(barre.dataset.stickyCtaTarget || '[data-buy-box]')];

      const afficher = (oui) => {
        barre.classList.toggle('is-visible', oui);
        barre.setAttribute('aria-hidden', oui ? 'false' : 'true');
      };

      if (!cibles.length) {
        afficher(false);
        return;
      }

      for (const bouton of barre.querySelectorAll('.sticky-cta__button')) {
        if (bouton.tagName !== 'BUTTON') continue;
        bouton.addEventListener('click', () => {
          cibles[0].scrollIntoView({
            block: 'start',
            behavior: MOUVEMENT_REDUIT.matches ? 'auto' : 'smooth',
          });
        });
      }

      const selArret = barre.getAttribute('data-sticky-cta-stop');
      const arrets = selArret ? [...document.querySelectorAll(selArret)] : [];
      let enAttente = false;

      const evaluer = () => {
        enAttente = false;

        const bloque = arrets.some((a) => {
          const r = a.getBoundingClientRect();
          return r.top < window.innerHeight && r.bottom > 0;
        });
        if (bloque) {
          afficher(false);
          return;
        }

        afficher(cibles.every((c) => c.getBoundingClientRect().bottom <= 0));
      };

      const planifier = () => {
        if (enAttente) return;
        enAttente = true;
        window.requestAnimationFrame(evaluer);
      };

      evaluer();
      window.addEventListener('scroll', planifier, { passive: true });
      window.addEventListener('resize', planifier);
    };

    const brancher = () => {
      for (const barre of document.querySelectorAll('[data-sticky-cta]')) equiper(barre);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
    document.addEventListener('shopify:section:load', brancher);
  })();

  } catch(e) { console.error(e); }
})();
})();
